import axios from 'axios'
import { useEffect, useState } from 'react'
import { EvalFormGroupSummary } from '../../../ApplicationManagement/EvaluationFormGroups/api'
import { evalFormGroupsUrl } from '../constants'

export function useActiveEvalFormGroups() {
  const [isLoading, setIsLoading] = useState(true)
  const [formGroupList, setFormGroupList] = useState<EvalFormGroupSummary[]>([])
  const [selectedFormGroup, setSelectedFormGroup] = useState<EvalFormGroupSummary | null>(null)
  useEffect(() => {
    const controller = new AbortController()
    axios.get<EvalFormGroupSummary[]>(evalFormGroupsUrl, { signal: controller.signal })
      .then((response => {
        setFormGroupList(response.data.sort(
          (a, b) => a.name.localeCompare(b.name),
        ))
      }))
      .catch((err: Error) => {
        if (!axios.isCancel(err)) {
          return err
        }
      })
      .finally(() => setIsLoading(false))
    return () => controller.abort()
  }, [])
  return { selectedFormGroup, formGroupList, setSelectedFormGroup, isLoading }
}
